<template>
  <a href="#contenu" class="skip-link">Aller au contenu</a>
  <router-view />
  <ExportDialog />
  <IconTooltip />

  <transition name="toast-slide">
    <div
      v-if="toast.visible"
      class="toast-notification"
      role="status"
      aria-live="polite"
      :style="{ backgroundColor: toastStyles[toast.type].bg, color: toastStyles[toast.type].color }"
    >
      <i :class="[toastStyles[toast.type].icon, 'me-2']" aria-hidden="true"></i>
      {{ toast.message }}
    </div>
  </transition>
</template>

<script setup>
import { useToast } from "@/composables/useToast.js";
import { onHttpEvent } from "@/api/http.js";
import ExportDialog from "@/components/ui/ExportDialog.vue";
import IconTooltip from "@/components/ui/IconTooltip.vue";

const { toast, styles: toastStyles, warning, error } = useToast();

onHttpEvent((type, response) => {
  if (type === "throttled") warning(response?.data?.message || "Trop de requêtes : patientez quelques instants.");
  if (type === "license-expired") error(response?.data?.message || "La licence de l'application a expiré.");
  if (type === "network") error("Impossible de joindre le serveur. Vérifiez votre connexion.");
});
</script>

<style>
.skip-link {
  position: absolute;
  left: -999px;
  top: 0.5rem;
  z-index: 2000;
  padding: 0.5rem 0.9rem;
  border-radius: var(--radius);
  background: hsl(var(--primary));
  color: hsl(var(--primary-foreground));
}
.skip-link:focus {
  left: 0.5rem;
}
.toast-notification {
  position: fixed;
  top: 1.25rem;
  left: 50%;
  transform: translateX(-50%);
  z-index: 3000;
  max-width: min(560px, calc(100vw - 2rem));
  padding: 0.75rem 1.1rem;
  border-radius: calc(var(--radius) + 2px);
  box-shadow: 0 10px 30px rgb(0 0 0 / 0.18);
  font-size: 0.9rem;
  font-weight: 500;
  display: flex;
  align-items: center;
}
.toast-slide-enter-active,
.toast-slide-leave-active {
  transition: all 0.3s ease;
}
.toast-slide-enter-from,
.toast-slide-leave-to {
  opacity: 0;
  transform: translateX(-50%) translateY(-16px);
}
</style>
